import {
    isSuccess,
    serializedErrorToWebDataError,
    webDataLoading,
    webDataNotAsked,
    webDataSuccess,
} from "@lvt/web-data";
import { createSlice } from "@reduxjs/toolkit";

import { fetchUserListsData, addUserLists, putUserFavData } from "@/api/users";

import { UserListsState } from "./types";


const initialState: UserListsState = {
    userListsData: webDataNotAsked(),
};

export const userListsSlice = createSlice({
    name: "userLists",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchUserListsData.pending, (state) => {
                state.userListsData = webDataLoading();
            })
            .addCase(fetchUserListsData.fulfilled, (state, action) => {
                state.userListsData = webDataSuccess(action.payload);
            })
            .addCase(fetchUserListsData.rejected, (state, action) => {
                state.userListsData = serializedErrorToWebDataError(action.error);
            })
            .addCase(addUserLists.fulfilled, (state, action) => {
                if (isSuccess(state.userListsData)) {
                    state.userListsData.payload.favorites = action.payload;
                }
            })
            .addCase(putUserFavData.fulfilled, (state, action) => {
                if (isSuccess(state.userListsData)) {
                    state.userListsData.payload.favorites = action.payload;
                }
            });
    },
});

export const userListsReducer = userListsSlice.reducer;
